import { Collapse, List, ListItem, ListItemIcon, ListItemText, makeStyles, } from "@material-ui/core";
import {
	ExpandLess,
	ExpandMore,
	List as ListIcon
} from "@material-ui/icons";
import { TranslationPrefixes } from "consts/translationPrefixes";
import React, { useEffect, useState } from "react";
import { WithTranslation, useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import { RoutesUrl } from "../../common/consts/Routes";
interface Route {
	route: string;
	label: string;
	icon: React.ReactNode;
	children?: Route[];
}

const getRoutes = (t: WithTranslation['t']): Route[] => {
	const { sideBar } = TranslationPrefixes
	return [
		// {
		// 	label: t(`${sideBar}clients`),
		// 	route: "clientshub",
		// 	icon: <ListIcon />,
		// 	children: [
		// 		{
		// 			label: t(`${sideBar}newClient`),
		// 			icon: <ListIcon />,
		// 			route: RoutesUrl.clients.create
		// 		},
		// 		{
		// 			label: t(`${sideBar}clients`),
		// 			icon: <ListIcon />,
		// 			route: RoutesUrl.clients.list
		// 		}
		// 	]
		// },
		// MODULE #3
		{
			label: "Paramertics Pro",
			route: "parametrics-pro",
			icon: <ListIcon />,
			children: [
				{
					label: "New Parametrics",
					icon: <ListIcon />,
					route: RoutesUrl.parametricsPro.create
				},
				{
					label: "Parametrics Data",
					icon: <ListIcon />,
					route: RoutesUrl.parametricsPro.list
				}
			]
		},
		// MODULE #4
		{
			label: "Customer Avatar",
			route: "avatars",
			icon: <ListIcon />,
			children: [
				{
					label: "New Avatar",
					icon: <ListIcon />,
					route: RoutesUrl.avatars.create
				},
				{
					label: "Avatar Data",
					icon: <ListIcon />,
					route: RoutesUrl.avatars.list
				}
			]
		},
		{
			label: "Market Guru",
			route: "guru",
			icon: <ListIcon />,
			children: [
				{
					label: "New Market Guru",
					icon: <ListIcon />,
					route: RoutesUrl.gurus.create
				},
				{
					label: "Market Guru Data",
					icon: <ListIcon />,
					route: RoutesUrl.gurus.list
				}
			]
		},
		// MODULE #5

		// ...
		// nothing yet
		// nothing yet
		// nothing yet
		// nothing yet
		// nothing yet
		// ...

		// {
		// 	label: t(`${sideBar}dashboard`),
		// 	route: "dashboard",
		// 	icon: <DashboardOutlined />,
		// 	children: [
		// 		{
		// 			label: t(`${sideBar}ordersVisualization`),
		// 			icon: <Timeline />,
		// 			route: RoutesUrl.dashboard.orders,
		// 		},
		// 		// {
		// 		// 	label: t(`${sideBar}productsProfit`),
		// 		// 	icon: <ListIcon />,
		// 		// 	route: RoutesUrl.dashboard.productsProfit,
		// 		// },
		// 		{
		// 			label: t(`${sideBar}profitBreakdown`),
		// 			icon: <ListIcon />,
		// 			route: RoutesUrl.dashboard.profitBreakdown,
		// 		},
		// 		{
		// 			label: t(`${sideBar}salesVisualizationRevenue`),
		// 			icon: <Timeline />,
		// 			route: RoutesUrl.salesVisualisation.totalRevenue,
		// 		},
		// 		{
		// 			label: t(`${sideBar}salesVisualizationNetProfit`),
		// 			icon: <Timeline />,
		// 			route: RoutesUrl.salesVisualisation.netProfit,
		// 		},
		// 		{
		// 			label: t(`${sideBar}products`),
		// 			icon: <ListIcon />,
		// 			route: RoutesUrl.dashboard.products,
		// 		},
		// 		{
		// 			label: t(`${sideBar}inventory`),
		// 			icon: <ListIcon />,
		// 			route: RoutesUrl.dashboard.inventory,
		// 		},
		// 	]
		// },
		// {
		// 	label: t(`${sideBar}orders`),
		// 	route: RoutesUrl.orders,
		// 	icon: <LocalOfferOutlined />,
		// },
		// {
		// 	label: t(`${sideBar}cogs`),
		// 	route: RoutesUrl.dashboard.cogs,
		// 	icon: <AttachMoney />,
		// },
		// {
		// 	label: t(`${sideBar}keyWords`),
		// 	route: RoutesUrl.keyWords.list,
		// 	icon: <TextFormat />,
		// 	children: [
		// 		{
		// 			label: t(`${sideBar}list`),
		// 			icon: <ListIcon />,
		// 			route: RoutesUrl.keyWords.list,
		// 		},
		// 		{
		// 			label: t(`${sideBar}new`),
		// 			icon: <AddCircle />,
		// 			route: RoutesUrl.keyWords.create,
		// 		},
		// 	]
		// },
		// {
		// 	label: t(`${sideBar}ads`),
		// 	route: "ads",
		// 	icon: <FeaturedPlayListOutlined />,
		// 	children: [

		// 		{
		// 			label: t(`${sideBar}list`),
		// 			icon: <ListIcon />,
		// 			route: RoutesUrl.ads.list,
		// 		},
		// 		{
		// 			label: t(`${sideBar}new`),
		// 			icon: <AddCircle />,
		// 			route: RoutesUrl.ads.create,
		// 		},

		// 	]
		// },
		// {
		// 	label: t(`${sideBar}reports`),
		// 	route: "business-reports",
		// 	icon: <DataUsageIcon />,
		// 	children: [
		// 		{
		// 			label: t(`${sideBar}businessReport`),
		// 			icon: <ListIcon />,
		// 			route: RoutesUrl.reports.business,
		// 		},
		// 		{
		// 			label: t(`${sideBar}inventoryReport`),
		// 			icon: <ListIcon />,
		// 			route: RoutesUrl.reports.inventory,
		// 		},
		// 		{
		// 			label: t(`${sideBar}listingsReport`),
		// 			icon: <ListIcon />,
		// 			route: RoutesUrl.reports.listings,
		// 		},
		// 	]
		// },

	]
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function SideMenu() {
	const location = useLocation();
	const history = useHistory();
	const { t } = useTranslation();

	const useStyles = makeStyles(() => ({
		icon: {
			minWidth: 30,
		},
		text: {
			whiteSpace: "nowrap",
		},
		root: {
			"&$disabled": {
				opacity: 1,
			},
		},
		disabled: {

		},
		child: {
			position: "relative",
			left: "6px",
			top: "-6px",
			fontSize: "20px",
		},
		nested: {
			"& span": {
				fontStyle: "italic",
			}
		},
		childNested: {
			paddingLeft: 25,
		}
	}));

	const routes = getRoutes(t);
	const classes = useStyles();

	const [open, setOpen] = useState("");

	const handleClick = (r: Route) => {
		const { route } = r;
		if (route === open) {
			setOpen("");
		} else {
			setOpen(r?.route || "");
		}
	}

	useEffect(() => {
		for (const route of routes) {
			if (route.children !== undefined) {
				const find = route.children.find((r) => `${r.route}` === location.pathname);

				if (find) {
					setOpen(find ? route.route : "");
					break;
				}

			}

			if (route.route === location.pathname) {
				setOpen(route.route);
				break;
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location]);

	return (
		<List>
			{
				routes.map((r) => {
					if (r.children) {
						return (
							<div key={`${r.route}-container`}>
								<ListItem key={`${r.route}-dropdown-list-item`} button onClick={() => handleClick(r)} >
									<ListItemIcon style={{ minWidth: 30 }}>
										{r.icon}
									</ListItemIcon>
									<ListItemText primary={r.label} classes={{ root: classes.text }} />
									{open === r.route ? <ExpandLess /> : <ExpandMore />}
								</ListItem>
								<Collapse in={open === r.route} timeout="auto" unmountOnExit>
									<List component="div" disablePadding>
										{
											r.children.map((rC) => {
												const link = `${rC.route}`;
												return (
													<ListItem button key={rC.route} className={rC.icon ? classes.childNested : classes.nested} selected={location.pathname === link} classes={{ root: classes.root, disabled: classes.disabled }} disabled={!rC.route} onClick={() => (rC.route ? (history.push(link)) : false)}>
														{rC.icon && <ListItemIcon classes={{ root: classes.icon }}>{rC.icon}</ListItemIcon>}
														<ListItemText primary={rC.label} />
													</ListItem>
												)
											})
										}
									</List>
								</Collapse>
							</div>
						)
					}

					return (
						<ListItem button key={`${r.route}-normal-list-item`} selected={location.pathname === r.route} onClick={() => (r.route ? (history.push(r.route)) : false)} disabled={r.route === undefined} classes={{ root: classes.root, disabled: classes.disabled }}>
							<ListItemIcon classes={{ root: classes.icon }}>{r.icon}</ListItemIcon>
							<ListItemText primary={r.label} classes={{ root: classes.text }} />
						</ListItem>
					)
				})
			}
		</List>
	);
}	
